import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'barcode',
    template: '<svg class="barcode"></svg>',
    standalone: false
})
export class BarcodeComponent implements OnInit {
  @Input() value: string;
  
  barcode: any;

  constructor(private element: ElementRef) { }

  ngOnInit() {
    let element = this.element.nativeElement.firstChild;
    let bc = (window as any).JsBarcode;
    this.barcode = new bc(element, this.value, {
      format: "code39"
    });
  }
}
